import { createContext, useContext, type ReactNode } from "react";
import type { BrokersSocietiesWithUsers } from "@dune/types";

type SelectedBrokerSocietyContextType = {
	selectedBrokerSociety: BrokersSocietiesWithUsers | null | undefined;
};

const SelectedBrokerSocietyContext = createContext<
	SelectedBrokerSocietyContextType | undefined
>(undefined);

export const SelectedBrokerSocietyProvider = ({
	children,
	selectedBrokerSociety,
}: {
	children: ReactNode;
	selectedBrokerSociety: BrokersSocietiesWithUsers | null | undefined;
}) => {
	return (
		<SelectedBrokerSocietyContext.Provider value={{ selectedBrokerSociety }}>
			{children}
		</SelectedBrokerSocietyContext.Provider>
	);
};

export const useSelectedBrokerSociety = () => {
	const context = useContext(SelectedBrokerSocietyContext);
	return context?.selectedBrokerSociety;
};
